import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { guardString } from "@msuite/utils/strings";
import { PersonioSyncNoteCell } from "./personio-sync-note-cell";
import { PersonioSyncResultCell } from "./personio-sync-result-cell";
import { PersonioSyncRowActions } from "./personio-sync-row-actions";
import { PersonioSyncStateTag } from "./personio-sync-state-tag";
import type { PersonioSyncRow } from "./utils";

const columnHelper = createColumnHelper<PersonioSyncRow>();

export const columns = [
	columnHelper.accessor((row) => `${row.firstName} ${row.lastName}`.trim(), {
		id: "name",
		header: localized("integrations.personio_sync.name"),
		size: 200,
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => guardString(row.email), {
		id: "email",
		header: localized("integrations.personio_sync.email"),
		size: 240,
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => row.action ?? row.state, {
		id: "status",
		header: localized("integrations.personio_sync.status"),
		size: 150,
		cell: (cell) => <PersonioSyncStateTag row={cell.row.original} />,
	}),
	columnHelper.accessor((row) => guardString(row.targetUserName), {
		id: "member",
		header: localized("integrations.personio_sync.member"),
		size: 200,
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.display({
		id: "note",
		header: localized("integrations.personio_sync.note"),
		size: 380,
		cell: (cell) => <PersonioSyncNoteCell row={cell.row.original} />,
	}),
	columnHelper.accessor((row) => row.result?.outcome ?? "", {
		id: "result",
		header: localized("integrations.personio_sync.result"),
		size: 160,
		cell: (cell) => <PersonioSyncResultCell row={cell.row.original} />,
	}),
	createRowActions(PersonioSyncRowActions),
];
